import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { ImageComponent } from '@libs/common/components';
import { HeroItemModel } from '@libs/cms/models';
import {
  PageBlockImpressionDirective,
  PageBlockLinkClickDirective,
  provideContentTrackingData,
} from '@libs/shared/tracking';
import { ContentLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-hero-slide',
  templateUrl: './hero-slide.component.html',
  styleUrls: ['./hero-slide.component.scss'],
  imports: [
    ImageComponent,
    ContentLinkDirective,
    MatAnchor,
    PageBlockImpressionDirective,
    PageBlockLinkClickDirective,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    provideContentTrackingData(HeroSlideComponent),
  ],
})
export class HeroSlideComponent {
  public readonly data: InputSignal<HeroItemModel> = input.required();
}
